import { client } from '../../utils/apolloClient';
import { environmentURLs } from '../../components/common/CaptureEnvironment';

export const mpDpService = {
  s3: {
    createSignedUrl: ({
      type,
      fileType = 'application/pdf',
      operation = 'getObject',
      expires,
      acl = 'public-read',
      fileName,
      token,
    }) => {
      let safeFileName;
      try {
        safeFileName = encodeURIComponent(decodeURIComponent(fileName));
      } catch {
        safeFileName = encodeURIComponent(fileName);
      }

      const url =
        `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/s3/signedUrl/create` +
        `?type=${encodeURIComponent(type)}` +
        `&fileType=${encodeURIComponent(fileType)}` +
        `&fileName=${safeFileName}` +
        `&operation=${encodeURIComponent(operation)}` +
        `&expires=${encodeURIComponent(expires)}` +
        `&acl=${encodeURIComponent(acl)}`;

      return client.authorizeRequest({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url,
      });
    },
  },
  cancel: {
    mp_dp_records: async (pendingEntities, token) => {
      return await client.authorizeRequest({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          pendingEntities,
        },
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/cancel/mp-dp-table-records/delete`,
      });
    },
    consent_records: async (pendingEntities, token) => {
      return await client.authorizeRequest({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          pendingEntities,
        },
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/cancel/documents-record/delete`,
      });
    },
    retry_records: async (pendingEntities, token) => {
      return await client.authorizeRequest({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          pendingEntities,
        },
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/cancel/retry-records/delete`,
      });
    },
    mp_subscription_records: async (pendingEntities, token) => {
      return await client.authorizeRequest({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          pendingEntities,
        },
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/cancel/marketplace-subscription-records/delete`,
      });
    },
  },
};
